import { language as lan_storeEmailSettingContent } from "./content";
import { language as lan_storeEmailSettingApiError } from "./api-error";

let language = {
    ...lan_storeEmailSettingContent,
    ...lan_storeEmailSettingApiError,
};

export { language }